import { useEffect, useRef } from 'react';
import { callCenterCallsApi } from '../utils/api';

const MAX_IDS_PER_REQUEST = 100;

/**
 * Polling سبک وضعیت رونویسی/خلاصه‌سازی چند تماس با یک درخواست (به جای دریافت جزئیات کامل هر تماس).
 *
 * @param {number[]} ids شناسه تماس‌هایی که در حال پردازش هستند؛ با خالی شدن، polling متوقف می‌شود.
 * @param {(updates: object[]) => void} onUpdate
 * @param {number} intervalMs
 */
export const useCallProcessingStatus = (ids, onUpdate, intervalMs = 5000) => {
  const onUpdateRef = useRef(onUpdate);
  onUpdateRef.current = onUpdate;

  // کلید پایدار: interval فقط با تغییر مجموعه شناسه‌ها دوباره ساخته می‌شود، نه با هر رندر
  const idsKey = [...new Set(ids)].sort((a, b) => a - b).slice(0, MAX_IDS_PER_REQUEST).join(',');

  useEffect(() => {
    if (!idsKey) return undefined;

    const idList = idsKey.split(',').map(Number);
    let inFlight = false;
    let cancelled = false;

    const tick = async () => {
      if (inFlight || document.hidden) return;
      inFlight = true;
      try {
        const res = await callCenterCallsApi.getProcessingStatus(idList);
        const updates = Array.isArray(res?.data) ? res.data : [];
        if (!cancelled && updates.length) onUpdateRef.current(updates);
      } catch {
        // خطای موقتی شبکه؛ در نوبت بعد دوباره تلاش می‌شود
      } finally {
        inFlight = false;
      }
    };

    const timer = setInterval(tick, intervalMs);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [idsKey, intervalMs]);
};

export default useCallProcessingStatus;
